import React from 'react'
import "../css/common.scss";
import logo from "../img/jst-logo.png";
export default function Navbar() {
  return (
    <>
    <header class="header">
        <div class="container">
          <div class="row">
            <div class="col">
                <div class="logo-img"><img src={logo} alt="logo" class="logo"/></div>
            </div>
           </div>
        </div>
    </header>
    </>
  )
}
